/* eslint-disable jsx-a11y/control-has-associated-label */
import {
  Skeleton,
  SkeletonBlock,
  SkeletonContent,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';
import React from 'react';

interface ITableSkeleton {
  colSpan: number;
  rows?: number;
}

export const TableSkeleton = ({ colSpan, rows = 4 }: ITableSkeleton) => {
  return (
    <>
      {Array(rows)
        .fill(true)
        .map((__: unknown, i: number) => (
          <tr key={i}>
            <td colSpan={colSpan}>
              <div
                className="sui-pt-4"
                style={{
                  border: '1px solid #CCCCCB',
                  width: '100%',
                  paddingLeft: '48px',
                  boxSizing: 'border-box',
                }}
              >
                <Skeleton
                  disablePadding
                  orientation="horizontal"
                  style={{ display: 'flex' }}
                >
                  <SkeletonContent
                    disablePadding
                    initialSize="full"
                    style={{ maxWidth: '50px', height: '50px' }}
                  >
                    <SkeletonBlock />
                  </SkeletonContent>
                  <SkeletonContent
                    disablePadding
                    initialSize="full"
                    style={{
                      width: '900px',
                      height: '50px',
                      marginLeft: '65px',
                    }}
                  >
                    <SkeletonLine variant="single" />
                    <SkeletonLine variant="single" />
                  </SkeletonContent>
                </Skeleton>
              </div>
            </td>
          </tr>
        ))}
    </>
  );
};
